import { create } from 'zustand'

interface ProfileSelectionState {
  selectedProfileId: string | null
  select: (id: string | null) => void
  clear: () => void
}

export const useProfileSelectionStore = create<ProfileSelectionState>()((set) => ({
  selectedProfileId: null,
  select: (id) => set({ selectedProfileId: id }),
  clear: () => set({ selectedProfileId: null }),
}))
